import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

import AppAlerts from '@/components/AppAlerts.vue'
import AppNavigation from '@/components/navigations/AppNavigation.vue'
import AppFooter from '@/components/navigations/AppFooter.vue'
import { computed, inject, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/useAuthStore'
import { ApiPluginInterface } from '@/plugins/api-plugin'
import useActivityTracker from '@/composables/useActivityTracker'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const api = inject<ApiPluginInterface>('api')
const storeAuth = useAuthStore()
storeAuth.loadRoles(api).then()
if (api) useActivityTracker(useRouter(), api.userActivity)

const isMounted = ref(false)
const route = useRoute()
const routePath = computed(() => route.path)

onMounted(() => {
    isMounted.value = true
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, { id: "v-app" }, {
    default: _withCtx(() => [
      (_unref(route).name !== 'redirecting')
        ? (_openBlock(), _createBlock(AppNavigation, { key: 0 }))
        : _createCommentVNode("", true),
      (isMounted.value)
        ? (_openBlock(), _createBlock(_component_v_main, { key: 1 }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_component_router_view, { key: routePath.value })),
              _createVNode(AppAlerts)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(route).name !== 'redirecting')
        ? (_openBlock(), _createBlock(AppFooter, { key: 2 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})